// Api's used in quotations and Quotations Dashboard page:
// Server base address from environment variable configured in .env.* files.
const serverBaseAddress = process.env.REACT_APP_SERVER_BASE_ADDRESS;

export { serverBaseAddress };
